import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => {
  return createStyles({
    gridWrapper: {
      height: '80vh',
    },
    header: {
      marginBottom: '1%',
    },
  });
});
